module.exports = __webpack_public_path__ + "static/media/sort-amount-down-alt.8037a217.svg";